import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/departamento`;
export const createDepartamento = async (alimento) => {
  return await axios.post(`${httpUrl}/create`, alimento).then((response) => response);
};

export const getListaDepartamento = async (filtros) => {
  return await axios.post(`${httpUrl}/listByFiltros`, filtros).then((response) => response);
};

export const getDepartamentoById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const deleteDepartamentoById = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};
